import { combineReducers } from '@reduxjs/toolkit';
import definitionRules from './DefinitionRules';
import generatedDefinitionPeriods from './GeneratedDefinitionPeriods';

export default combineReducers({
  definitionRules,
  generatedDefinitionPeriods,
});
